import { useMemo, useState } from 'react';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { getEmailMetadata } from 'conversations-message-history/common-message-format/operators/getEmailMetadata';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getCallMetadataAttachment } from 'conversations-message-history/call/operators/callMetadataAttachmentGetters';
// @ts-expect-error module not typed
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import CommonMessageHeaderPopoverList from './CommonMessageHeaderPopoverList';
import { getEmailMessagePopoverContents } from './getEmailMessagePopoverContents';
import { getCallMessagePopoverContents } from './getCallMessagePopoverContents';
import { getCommonMessageHeaderContents } from './getCommonMessageHeaderContents';
import { usageTracker } from '../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../usage-tracker/trackerChannelIdMapping';
import { DownCaratIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const CommonMessageHeaderPopover = ({
  message,
  sender,
  isSenderLoading,
  recipient,
  isRecipientLoading,
  genericChannelId,
  friendlyNames
}) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const handlePopoverToggle = () => {
    setPopoverOpen(!popoverOpen);
  };
  const onClickMessageActionsButton = () => {
    handlePopoverToggle();
    usageTracker.track('click-dropdown', {
      action: 'click dropdown',
      channel: getUsageTrackingChannel(genericChannelId)
    });
  };
  const options = useMemo(() => {
    if (isCommonMessageFormat(message) && Boolean(getEmailMetadata(message))) {
      return getEmailMessagePopoverContents({
        message,
        friendlyNames
      });
    }
    const callMetadata = getCallMetadataAttachment(message);
    if (callMetadata) {
      return getCallMessagePopoverContents({
        message,
        sender,
        isSenderLoading,
        recipient,
        isRecipientLoading
      });
    }
    return getCommonMessageHeaderContents({
      message
    });
  }, [friendlyNames, message, sender, isSenderLoading, recipient, isRecipientLoading]);
  if (options.length === 0) return null;
  return /*#__PURE__*/_jsx(Popover, {
    open: popoverOpen,
    closeOnOutsideClick: true,
    onOpenChange: handlePopoverToggle,
    content: /*#__PURE__*/_jsx(CommonMessageHeaderPopoverList, {
      options: options,
      genericChannelId: genericChannelId
    }),
    children: /*#__PURE__*/_jsx(IconButton, {
      size: "sm",
      use: "transparent",
      "data-test-id": "call-message-popover-button",
      onClick: onClickMessageActionsButton,
      paddingInlineStart: "0",
      children: /*#__PURE__*/_jsx(DownCaratIcon, {})
    })
  });
};
CommonMessageHeaderPopover.displayName = 'CommonMessageHeaderPopover';
export default CommonMessageHeaderPopover;